var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34.4 34.4",
    style: {
      enableBackground: "new 0 0 34.4 34.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,0C7.7,0,0,7.7,0,17.2s7.7,17.2,17.2,17.2s17.2-7.7,17.2-17.2S26.7,0,17.2,0z M29.9,10.8h-5.8 c-0.7-2.8-1.7-5.3-3.1-7.3C24.8,4.6,28.1,7.3,29.9,10.8z M31.4,17.2c0,1.2-0.2,2.3-0.4,3.4h-6.4c0.1-1.1,0.2-2.2,0.2-3.4 c0-1.2-0.1-2.3-0.2-3.4H31C31.3,14.9,31.4,16,31.4,17.2z M16.9,31c-1.8-1.6-3.2-4.3-4.1-7.4H21C20.1,26.7,18.7,29.4,16.9,31z  M12.2,20.6c-0.1-1.1-0.2-2.2-0.2-3.4s0.1-2.3,0.2-3.4h9.4c0.1,1.1,0.2,2.2,0.2,3.4s-0.1,2.3-0.2,3.4H12.2z M3,17.2 c0-1.2,0.2-2.3,0.4-3.4h5.8C9.1,14.9,9,16.1,9,17.2s0.1,2.3,0.2,3.4H3.4C3.2,19.5,3,18.4,3,17.2z M16.9,3.4c1.8,1.6,3.2,4.3,4.1,7.4 h-8.2C13.7,7.7,15.1,5,16.9,3.4z M12.7,3.7c-1.3,2-2.4,4.4-3,7.1H4.5C6.2,7.5,9.1,4.9,12.7,3.7z M4.5,23.6h5.2 c0.6,2.7,1.7,5.1,3,7.1C9.1,29.5,6.2,26.9,4.5,23.6z M20.9,30.9c1.4-2,2.5-4.5,3.1-7.3h5.8C28.1,27.2,24.8,29.8,20.9,30.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/web-icon.bc65f5b23184c33e0a8339430977d206.svg";
export { ForwardRef as ReactComponent };